<template>
  <div>
    <dara-form v-if="user" :submit="create">
      <div class="row mt-4">
        <div class="form-field col-18 col-lg-9">
          <dara-input
            v-model="user.name"
            :label="$t('first-name') + '*'"
            :name="$t('first-name-field')"
            type="text"
            rules="required"
            :placeholder="$t('user-first-name-placeholder')" />
        </div>

        <div class="form-field col-18 col-lg-9">
          <dara-input
            v-model="user.last_name"
            :label="$t('last-name') + '*'"
            :name="$t('last-name-field')"
            type="text"
            rules="required"
            :placeholder="$t('user-last-name-placeholder')" />
        </div>

        <div class="form-field col-18 col-lg-9">
          <dara-input
            v-model="user.email"
            :label="$t('email') + '*'"
            :name="$t('email-field')"
            type="text"
            rules="required"
            :placeholder="$t('user-email-placeholder')" />
        </div>

        <div class="form-field col-18 col-lg-9">
          <dara-input
            v-model="user.position"
            :label="$t('position') + '*'"
            :name="$t('position-field')"
            type="text"
            rules="required"
            :placeholder="$t('user-position-placeholder')" />
        </div>
        <div class="form-field col-18 col-lg-9">
          <fieldset class="form-group">
            <label for="permission" class="w-100 mb-2">{{ $t('permission') }}</label>
            <div id="permission" class="form-check form-check-inline">
              <label class="form-check-label">
                <input
                  id="readerOption"
                  v-model="user.permission"
                  type="radio"
                  class="form-check-input"
                  name="optionsRadios"
                  value="0">
                {{ $t('reader') }}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input
                  id="writerOption"
                  v-model="user.permission"
                  type="radio"
                  class="form-check-input"
                  name="optionsRadios"
                  value="1">
                {{ $t('writer') }}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input
                  id="superUserOption"
                  v-model="user.permission"
                  type="radio"
                  class="form-check-input"
                  name="optionsRadios"
                  value="2">
                {{ $t('admin') }}
              </label>
            </div>
          </fieldset>
        </div>
        <div class="form-field col-18 col-lg-9">
          <dara-department-chooser
            ref="departmentChooser"
            v-model="user.department_id"
            @on-change="onDepartmentUserChange"
            @onNewDepartment="onNewDepartment" />
        </div>
      </div>

      <div class="mt-4 mb-2 d--flex justify-content-end">
        <dara-button
          class="btn btn-secondary"
          width="110"
          size="sm"
          @click="goHistoryBack()">
          {{ $t('cancel') }}
        </dara-button>
        <dara-button
          native-type="submit"
          class="btn btn-success ms-2"
          width="110"
          size="sm">
          {{ $t('create') }}
        </dara-button>
      </div>
    </dara-form>
    <hr class="mt-4">
    <div>
      <dara-header class="mt-4">{{ $t('import-users') }}</dara-header>
      <dara-row class="align-items-center">
        <dara-col :xs="24" :span="12">
          <div class="mt-4 mb-1">
            <form>
              <div class="form-group">
                <input
                  id="csvFormFile"
                  type="file"
                  class="form-control-file">
              </div>
            </form>
          </div>
          <small class="text-muted">
            {{ $t('download-csv-model') }}
            <a class="text-primary" @click="downloadModel">{{ $t('here') }}</a>
          </small>

          <dara-invisible v-if="existingUsersEmail.length > 0">
            <dara-p class="mt-4" size="lg" weight="strong">
              {{ $t('inserted-users') }}
              {{ (totalUsers - existingUsersEmail.length) }} {{ $t('of') }} {{ totalUsers }}
            </dara-p>
            <dara-p class="mt-1" size="lg" weight="strong">
              {{ $t('email-already-registered') }}
            </dara-p>
            <dara-p
              v-for="(item, index) in existingUsersEmail"
              :key="index"
              color="danger"
              size="lg">
              • {{ item }}
            </dara-p>
          </dara-invisible>
        </dara-col>
        <dara-col :xs="24" :span="12" justify="left">
          <dara-department-chooser
            ref="departmentChooserImport"
            v-model="user.department_id"
            class="mt-4"
            style="margin-bottom: -16px"
            @on-change="onDepartmentImportChange"
            @onNewDepartment="onNewDepartment" />
          <small class="text-muted dara-u-text--small d-block">
            {{ $t('the-chosen-department-will-be-associated-to') }} <strong>{{ $t('all-imported-users') }}</strong>.
          </small>
        </dara-col>
      </dara-row>
      <div class="mt-4 mb-2 d--flex justify-content-end">
        <dara-button
          native-type="submit"
          class="btn btn-primary mt-3"
          width="110"
          size="sm"
          @click="importUsers">
          {{ $t('import') }}
        </dara-button>
      </div>
    </div>

    <dara-modal-new-department
      v-if="showModal()"
      ref="departmentModal"
      @close="closeModal()">
    </dara-modal-new-department>
  </div>
</template>

<script>
import { toastError } from '@/services/toastService';
import { translate } from '@/services/translate.service';
import { goHistoryBack } from '@/router/route.service';
import { getters } from '@/modules/user/user.store';
import DaraDepartmentChooser from '@/modules/department/components/DepartmentChooser.vue';

export default {
  name: 'DaraUserCreateInformation',
  components: {
    DaraDepartmentChooser,
  },
  inject: ['userEditVm'],
  props: {
    existingUsersEmail: {
      type: Array,
      required: true,
    },
    totalUsers: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      user: this.userEditVm.user,
      department: null,
      newDepartment: false,
      performer: getters.getUser(),
    };
  },
  methods: {
    goHistoryBack,
    create() {
      this.$emit('create');
    },
    importUsers() {
      const csvFile = document.getElementById('csvFormFile');
      if (csvFile.files.length > 0) {
        this.$emit('import', csvFile, this.department);
      } else {
        toastError(`${translate('you-need-to-select-a-file')}`);
      }
    },
    downloadModel() {
      const data = [
        ['Lucas', 'Debatin', 'lucas@darateste.com', 'Marketing Manager', '1'],
        ['Emanuel', 'Pedrozo', 'emanuel@darateste.com', 'Vice President of Marketing', '2'],
        ['João', 'Ribeiro', 'joao@darateste.com', 'Just the Developer', '0'],
      ];

      let csv = 'name,last_name,email,position,permission\n';
      data.forEach(row => {
        csv += row.join(',');
        csv += '\n';
      });

      const hiddenElement = document.createElement('a');
      hiddenElement.href = `data:text/csv;charset=utf-8,%EF%BB%BF ${encodeURI(csv)}`;
      hiddenElement.target = '_blank';
      hiddenElement.download = 'model_employees.csv';
      hiddenElement.click();
    },
    onDepartmentUserChange(department) {
      this.user.department_id = department.id;
    },
    onDepartmentImportChange(department) {
      this.department = department;
    },
    onNewDepartment() {
      this.newDepartment = true;
    },
    showModal() {
      return this.newDepartment;
    },
    closeModal() {
      this.$refs.departmentChooser.onfetch();
      this.$refs.departmentChooserImport.onfetch();
      this.newDepartment = false;
    },
  },
};
</script>
